// Check if Zinc analytics library is loaded
/**
 * @returns {boolean} True if Zinc analytics library is loaded, false otherwise
 */
const isZincLoaded = () => {
    window.zincTag = window.zincTag || []; // Initialize zincTag to prevent "Zinc is not defined" errors
    return !!(window.zincTag && typeof window.zincTag === 'object');
};
let isFirstAddToCart = true;
// ✅ Add this variable to store the selected plan object
let selectedPlanObject = null;

const getEligibleProducts = (response) => {
    let eligibleProducts = [];
    if (response?.data?.QualifiedCBand || response?.data?.Qualified) {
        eligibleProducts.push("5g");
    }
    if (response?.data?.Qualified_4g || response?.data?.Qualified4GHome) {
        eligibleProducts.push("lte");
    }
    if (response?.data?.LQPost?.HSIStatus) {
        eligibleProducts.push("hsi");
    }
    if (response?.data?.LQPost?.FiOSDataStatus) {
        eligibleProducts.push("fios");
    }
    if (response?.data?.ftrQualification?.FtrQualified === "Y") {
        eligibleProducts.push("ftr"); 
    }
    return eligibleProducts.length > 0 ? eligibleProducts.join(" + ") : "5g";
}

export const omniTrackPageView = (pageName, flowName, channelName) => {
    if (isZincLoaded()) {
        try {
            window['zincTag'].push({
                task: "definePage",
                params: {
                    type: "fios.base",// Static
                    pageName: pageName,//dynamic
                    flow: flowName,//dynamic
                    channel: channelName,//dynamic
                }
            });
        } catch (error) {
            console.error('Error pushing to zincTag:', error);
        }
    }
}
export const omniTrackOpenView = (pageName, selector) => {
    try {
        window['zincTag'].push({
            task: "fios.openView",//Static,
            params: {
                payload: {
                    trackAs: "link",//Static,
                    selector: selector, //dynamic
                    name: pageName, //dynamic based on techspec
                    event: "", //prodView ------will capture products,
                    doProduct: false
                }
            }
        })


    } catch (error) {
        console.error('Error pushing to zincTag:', error);
    }

}

export const omniTrackLQAttempts = (request, response) => {
    try {
        // console.log("LQA req res: ", request, response);
        if (isZincLoaded()) {
            // Generate dynamic checking parameter based on qualifications
            const checkingParam = getEligibleProducts(response);
            // console.log("Checking params", checkingParam);
            const params = {
                checking: checkingParam,
                zip: request?.zipCode,
                hashedAddress: response?.data?.AddressId,
            };
            window['zincTag'].push({
                task: "fios.loopQual",//static and manditory
                params: {
                    version: 2,//static
                    type: "LQA",//static and manditory
                    ...params
                }
            });
        }
    } catch (error) {
        console.error('Error pushing to zincTag:', error);
    }
};

export const omniTrackLQSuccess = (request, response) => {
    try {
        if (isZincLoaded()) {
            // Generate dynamic checking parameter based on qualifications
            let eligibleProducts = null;
            if(response.data) {
            eligibleProducts = getEligibleProducts(response);
            // console.log("Eligible params", eligibleProducts);
            }
            window['zincTag'].push({
                task: "fios.loopQual",//static and manditory
                params: {
                    version: 2,//static
                    type: "LQS",//static and manditory
                    zip: request?.zipCode ? request?.zipCode : request?.zip,
                    hashedAddress: "",
                    addressId: response?.data?.AddressId ? response?.data?.AddressId : request?.baseAddressId,
                    eligible: eligibleProducts ? eligibleProducts : []
                }
            });
        }
    } catch (error) {
        console.error('Error pushing to zincTag:', error);
    }
};

export const notifyEvent = (messageStatus, message, isError) => {
    try {
        if (isZincLoaded()) {
            const params = {
                name: messageStatus, //dynamic based on the techspec, example: "LQA Failure", "LQA Success", "Address Validation Failure" ....etc
                message: message, //dynamic
            };
            
            // Only add isError if it's true
            if (isError) {
                params.isError = true;
            }
            
            window['zincTag'].push({
                task: "notify",
                params: params
            });
        }
    } catch (error) {
        console.error('Error pushing to zincTag:', error);
    }

}

export const prodView = (pageName, productType, pdpMockData) => {
    window['zincTag'].push({
        task: "definePage",
        params: {
            type: "fios.PDP",// Static
            src: pdpMockData,//dynamic
            pageName: pageName,//dynamic based on spec
            productType: productType || "",//dynamic based on the product plan,accessory,feature ...etc
            flow: "", //dynamic
            channel: "Order", //dynamic
        }
    });

}

export const shoppingCart = (pageName, scType, cartMockData) => {
    const enrichedCartData = addMetadata(cartMockData, "shoppingCart");
    // console.log(enrichedCartData, "enrichedCartData");
    try {
        if (isZincLoaded()) {
            window['zincTag'].push({
                task: "definePage",//Static,
                params: {
                    type: "fios.Cart",//Static,
                    event: scType,//dynamic scView, scCheckout,
                    cartSrc: enrichedCartData,// dynamic GetCartDetails response
                    pageName: pageName,//dynamic based on the techspec
                    user: "",//dynamic based on the techspec
                    flow: "gborder",//dynamic based on the techspec
                    channel: "order",//dynamic based on the techspec
                }

            });
        }
    } catch (error) {
        console.error('Error pushing to zincTag:', error);
    }
}

export const addToCart = (params, cartType) => {
    let cartMockData = {};

      // Handle direct cart data (from TVChannelNew.js)
    if (cartType == "phone") {
        cartMockData = { phone: params.phone };
    } else if(cartType == "tvservice") {
        let { props } = params;
        const mainPlan = props?.DataInfo?.FIOSTVInfo?.Plans?.MainPlan || {};
        const filterService = Object.values(mainPlan).flat().find(plan => plan?.ProductId === props.storeOldID);
        if (filterService) {
            cartMockData = { tvservice: [filterService] };
        }
    } else if(cartType == "tvplan") {
        cartMockData = { tvplan: params.tvplan };
    } else if( cartType === "software") {
        const { props } = params;
        const vasProdInfo = props?.customizeProductsResponse?.DataInfo?.Addons?.VasProdInfo || [];
        let selectedProduct = null;
           // Find the selected product across all VasProdInfo entries
        for (const productIdGroup of vasProdInfo) {
            const found = productIdGroup?.VasProducts?.find(product => product.ProductId === props.isSelectedValue);
            if (found) {
                selectedProduct = found;
                break; // Exit loop once found
            }
        }
        // Use the selected product if found, otherwise use the original software
        cartMockData = { software: [selectedProduct] };
    } else if(cartType === "own router") {
        const { storeOwnRouter, props } = params;
        const selectedRouterObject = props.DataPlan?.Routers?.find(router => router.ProductId === storeOwnRouter.PrdId);
        cartMockData = { router: [selectedRouterObject] };
    } else if (cartType === "plan tile") {
    const { ProductId, fromEquipment, routerType, planSel, props } = params;

    const clickType = fromEquipment ? (routerType === 'own' ? 'ownRouter' : (planSel ? 'selectedRouter' : 'router')) : (planSel ? 'selectedPlan' : 'plan');
    if (clickType === 'plan' || clickType === 'selectedPlan') {
        // Only send the newly clicked plan, no router
        if (props?.DataPlan?.Plans) {
            const allPlans = props.DataPlan.Plans;
            const selectedPlan = allPlans.find(plan => plan?.ProductId === ProductId);
            selectedPlanObject = selectedPlan; // Store the selected plan object for later use in metadata
            cartMockData = { plan: [selectedPlan] };
        }
        // Do NOT add router - leave it empty
    } else if (clickType === 'router' || clickType === 'selectedRouter') {
        // Only send the newly clicked router, no plan
        if (props?.DataPlan?.Routers) {
            const allRouters = props?.DataPlan?.Routers;
            const selectedRouterObject = allRouters.find(router => router?.ProductId === ProductId);
            cartMockData = { router: [selectedRouterObject] };
            }
        // Do NOT add plan - leave it empty
    } else {
        console.log('plan, router, ownRouter, tvplan, tvservice, software, phone - no matching click type found for addToCart');
        return;
    }
}
        // Send individual item
        window['zincTag'].push({
            task: "fios.addToCart",
            params: {
                openCart: isFirstAddToCart, // first product to cart scOpen then rest of product when adding it will be scAdd
                src: cartMockData //dynamic based on the API
            }
        });

    // Set to false after first call
    if (isFirstAddToCart) {
        isFirstAddToCart = false;
    }
}

export const purchaseEvent = (pageName, purchaseMockData) => {
    const updatedPurchaseData = addMetadata(purchaseMockData, "purchase");
    // console.log(updatedPurchaseData, "updatedPurchaseData");
    window['zincTag'].push({
        task: "definePage",//Static,
        params: {
            type: "fios.Cart",//Static,
            event: 'purchase',//Static,
            cartSrc: updatedPurchaseData,// dynamic
            pageName: pageName,//dynamic based on the techspec
            user: "",//dynamic based on the techspec
            flow: "",//dynamic based on the techspec
            channel: "order",//dynamic based on the techspec

        }
    })
}

//omni tagging - event tracking
    export const trackTransactionEvent = (params) => {
        window['zincTag'].push({
            task: "mybizreact.coreDataCall",
            event:'fragment',
            params: {
                events: params.events,
                id: params.id,
                now : true, //fires at immediatly,
            }
        });
    }

// Add metadata to cart response
const addMetadata = (response, type) => {
    if (!response?.planDetails && !response?.floatCartResponse?.planDetails) return response;

    const enriched = JSON.parse(JSON.stringify(response));
    const pd = enriched.planDetails || enriched.floatCartResponse?.planDetails;

    // dataInfo metadata
    if (pd?.dataInfo) {
        const { planName, planPrice, hasTechProOffer, ...nestedObjects } = pd.dataInfo;

        // Keep existing properties as-is
        pd.dataInfo = {
            planName,
            planPrice,
            hasTechProOffer
        };

         // ✅ Add metaData object if selectedPlanObject exists
        if (selectedPlanObject) {
            pd.dataInfo.metaData = {
                ...selectedPlanObject
            };
        }

        // Wrap any additional nested objects in metaData
        if (Object.keys(nestedObjects).length > 0) {
            Object.keys(nestedObjects).forEach(key => {
                if (typeof nestedObjects[key] === 'object' && nestedObjects[key] !== null) {
                    pd.dataInfo[key] = {
                        metaData: nestedObjects[key]
                    };
                } else {
                    // Keep primitive values as-is
                    pd.dataInfo[key] = nestedObjects[key];
                }
            });
        }
    }

    // tvInfo metadata
    if (pd?.tvInfo) {
        const { tvServices, ...rest } = pd.tvInfo;

        pd.tvInfo = {
            metaData: {
                ...rest
            }
        };

        // if (tvServices?.length) {
        //     pd.tvInfo.tvServices = tvServices.map((s) => ({
        //         metaData: {
        //             ...s
        //         }
        //     }));
        // }
        if (tvServices?.length) {
            pd.tvInfo.tvServices = tvServices.map((s) => {
                const service = {};
                const metaData = {};

                // Dynamically separate primitive values from nested objects
                Object.entries(s).forEach(([key, value]) => {
                    if (value !== null && typeof value === 'object') {
                        // If it's an object or array, put it in metaData
                        metaData[key] = value;
                    } else {
                        // If it's a primitive (string, number, boolean, null), keep it at root
                        service[key] = value;
                    }
                });

                // Only add metaData if there are nested objects
                if (Object.keys(metaData).length > 0) {
                    service.metaData = metaData;
                }

                return service;
            });
        }
    }

    // otherServices metadata
    if (pd?.otherServices?.length) {
        pd.otherServices = pd.otherServices.map((s) => ({
            metaData: {
                ...s
            }
        }));
    }

    // equipmentAndOnetimeCharges metadata
    if (pd?.equipmentAndOnetimeCharges?.length) {
        pd.equipmentAndOnetimeCharges = pd.equipmentAndOnetimeCharges.map((c) => ({
            metaData: {
                ...c
            }
        }));
    }

    if (type === "purchase") {
        return {
            orderInfo: response?.orderInfo,
            floatCartInfo: enriched?.floatCartResponse
        };
    }

    return enriched;
};